const isProduction = false;
// Externel Ip Setting
export const api = isProduction ? 'http://tabvn.com' : '';
